import { Text } from "recharts";
import PropTypes from "prop-types";

const CustomXAxisTick = ({ x, y, payload }) => {
  return (
    <Text x={x} y={y} width={95} textAnchor="middle" verticalAnchor="start">
      {payload.value}
    </Text>
  );
};

CustomXAxisTick.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  payload: PropTypes.shape({
    value: PropTypes.number.isRequired
  })
};

export default CustomXAxisTick;
